export type CsvColumn<T> = { label: string; key: keyof T };

function escapeCsvValue(value: any): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  const needsQuotes = /[",\n\r]/.test(s);
  const escaped = s.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
}

/**
 * Convert array of objects to CSV string
 * @param data - array of objects
 * @param columns - optional columns to control order and labels. If omitted, keys from first object are used.
 */
export function toCsv<T extends Record<string, any>>(
  data: T[],
  columns?: CsvColumn<T>[]
): string {
  if (!data || data.length === 0) {
    const headerRow = columns ? columns.map(c => c.label).join(",") : "";
    return headerRow + "\n";
  }

  const cols: CsvColumn<T>[] =
    columns ??
    Object.keys(data[0]).map(k => ({ label: k, key: k })) as CsvColumn<T>[];

  const header = cols.map(c => `"${String(c.label).replace(/"/g, '""')}"`).join(",");

  const rows = data.map((row) =>
    cols.map(c => escapeCsvValue(row[c.key as string])).join(",")
  );

  return [header, ...rows].join("\r\n");
}
